import axios from 'axios';

const ACCESS_KEY_STORAGE = 'newsflash_ai_access_key';

const api = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function getAccessKey() {
  return window.sessionStorage.getItem(ACCESS_KEY_STORAGE) || '';
}

function storeAccessKey(key) {
  if (key) {
    window.sessionStorage.setItem(ACCESS_KEY_STORAGE, key);
  }
}

function clearAccessKey() {
  window.sessionStorage.removeItem(ACCESS_KEY_STORAGE);
}

function withAccessKey(config = {}) {
  const key = getAccessKey();
  if (!key) {
    return config;
  }

  return {
    ...config,
    params: {
      ...(config.params || {}),
      k: key,
    },
  };
}

export default {
  getAccessKey,
  storeAccessKey,
  clearAccessKey,

  listQueue() {
    return api.get('/api/newsflash-ai/queue', withAccessKey());
  },

  listJaPending() {
    return api.get('/api/newsflash-ai/queue/sent-ja', withAccessKey());
  },

  listFiltered() {
    return api.get('/api/newsflash-ai/queue/filtered', withAccessKey());
  },

  listPublished() {
    return api.get('/api/newsflash-ai/published', withAccessKey());
  },

  deletePublished(id) {
    return api.post(`/api/newsflash-ai/published/${encodeURIComponent(id)}/delete`, {}, withAccessKey());
  },

  clearQueue() {
    return api.post('/api/newsflash-ai/queue/clear', {}, withAccessKey());
  },

  getQueueItem(id) {
    return api.get(`/api/newsflash-ai/queue/${encodeURIComponent(id)}`, withAccessKey());
  },

  sendToJa(id) {
    return api.post(`/api/newsflash-ai/queue/${encodeURIComponent(id)}/send-ja`, {}, withAccessKey());
  },

  sendBatchToJa(ids) {
    return api.post('/api/newsflash-ai/queue/send-ja-batch', { ids }, withAccessKey());
  },

  discard(id) {
    return api.post(`/api/newsflash-ai/queue/${encodeURIComponent(id)}/discard`, {}, withAccessKey());
  },

  getJaItem(id) {
    return api.get(`/api/newsflash-ai/ja/${encodeURIComponent(id)}`, withAccessKey());
  },

  getJaBatch(ids) {
    return api.get('/api/newsflash-ai/ja/batch', withAccessKey({
      params: {
        ids: ids.join(','),
      },
    }));
  },

  getJaPublishedItem(slug) {
    return api.get(`/api/newsflash-ai/ja/published/${encodeURIComponent(slug)}`, withAccessKey());
  },

  approveJa(id) {
    return api.post(`/api/newsflash-ai/ja/${encodeURIComponent(id)}/approve`, {}, withAccessKey());
  },

  approveJaBatch(selectedIds, batchIds) {
    return api.post('/api/newsflash-ai/ja/batch/approve', {
      selected_ids: selectedIds,
      batch_ids: batchIds,
    }, withAccessKey());
  },

  rejectJa(id) {
    return api.post(`/api/newsflash-ai/ja/${encodeURIComponent(id)}/reject`, {}, withAccessKey());
  },

  rejectJaBatch(batchIds) {
    return api.post('/api/newsflash-ai/ja/batch/reject', {
      batch_ids: batchIds,
    }, withAccessKey());
  },

  runCapture() {
    return api.post('/api/newsflash-ai/run', {}, withAccessKey());
  },
};
